import {
  DECORATION_CONSULT_GIFT,
  DECORATION_GIFT,
  DECORATION_MEAL,
  DECORATION_MERCHANT_PROMISE,
  DECORATION_RECOMMEND_WINDOW
} from '@constant'

// 装修
export const DECORATION = {
  title: '店铺装修',
  desc: '展示升级，吸引用户关注',
  list: [
    {
      title: '主题模板',
      desc: '个性化定制店铺',
      img: 'https://qnm.hunliji.com/o_1cvml97b81e7c131r17jb1qn72q3i.png',
      link: '#/localMerchant/themeChose',
      key: 'pro_decoration_theme_chose'
    },
    {
      title: '推荐橱窗',
      desc: '用主打作品抓住客户',
      img: 'https://qnm.hunliji.com/o_1cvml97b81pto1ugmdau5e11a8ih.png',
      link: `#/localMerchant/decoration?type=${DECORATION_RECOMMEND_WINDOW}`,
      key: 'pro_decoration_show_case'
    },
    {
      title: '套餐热标',
      desc: '打造店铺爆款',
      img: 'https://qnm.hunliji.com/o_1cvml97b865q7c81bev151c1oapg.png',
      // link: `#/localMerchant/decoration?type=${DECORATION_MEAL}&top=1500`,
      link: `#/localMerchant/decoration?type=${DECORATION_MEAL}`,
      key: 'pro_decoration_marketing_tool_17'
    },
    {
      title: '商家承诺',
      desc: '加强信任，促进下单',
      img: 'https://qnm.hunliji.com/o_1cvml97b8vu9hls1ehb7pr1okf.png',
      link: `#/localMerchant/decoration?type=${DECORATION_MERCHANT_PROMISE}`,
      key: 'pro_decoration_marketing_tool_5'
    },
    {
      title: '咨询礼',
      desc: '促进客户主动发起咨询',
      img: 'https://qnm.hunliji.com/o_1cvml97b8107c2dp10811tl1ctvj.png',
      link: `#/localMerchant/decoration?type=${DECORATION_CONSULT_GIFT}`,
      key: 'pro_decoration_marketing_tool_32'
    },
    {
      title: '到店礼',
      desc: '提升客户到店意愿',
      img: 'https://qnm.hunliji.com/o_1cvml97b86rhg271q931q8nlg4e.png',
      link: `#/localMerchant/decoration?type=${DECORATION_GIFT}`,
      key: 'pro_decoration_marketing_tool_1'
    }
  ]
}

// 营销
export const MARKETING = {
  title: '营销转化',
  desc: '多功能协同，让你的客源不断',
  list: [
    {
      title: '轻松聊',
      desc: '主动出击转化意向客户',
      img: 'https://qnm.hunliji.com/o_1cvmnaqoc1vepv791qt2b3li96e.png',
      // link: '#/localMerchant/easyChat',
      link: '#/localMerchant/marketingCenter/detail/80',
      key: 'pro_marketing_detail_80'
    },
    {
      title: '天眼系统',
      desc: '大数据助你获取潜在客资',
      img: 'https://qnm.hunliji.com/o_1cvmnaqoc12dl1hth18ia3vfusof.png',
      link: '#/localMerchant/marketingCenter/detail/81',
      key: 'pro_marketing_detail_81'
    },
    {
      title: '优惠券',
      desc: '提升订单转化利器',
      img: 'https://qnm.hunliji.com/o_1cvmnaqoc14fs1obk5d814t41550g.png',
      link: '#/localMerchant/marketingCenter/detail/82',
      key: 'pro_marketing_detail_82'
    },
    {
      title: '聚客宝',
      desc: '助你获取平台精准客资',
      img: 'https://qnm.hunliji.com/o_1cvmnaqocsri1q681qjt1ksd1hb9h.png',
      link: '#/localMerchant/jukeTreasure',
      key: 'pro_marketing_detail_juke'
    },
    {
      title: '潜在客资转化',
      desc: '潜在客资批量联系转化',
      img: 'https://qnm.hunliji.com/o_1cvmnaqob15fi1uha1bn914ig1peud.png',
      link: '#/localMerchant/skyEyeSystem?tab=2',
      key: 'pro_marketing_potential_customers'
    }
  ]
}

// 获客渠道
export const CUSTOMER_DEVELOPMENT = {
  title: '获客拓展',
  desc: '多渠道引流，提升品牌知名度',
  list: [
    {
      title: '微传单+',
      desc: '主动把握意向客户',
      img: 'https://qnm.hunliji.com/o_1cvmnpl5u1r9hae7h971oc51fq6d.png',
      link: '#/localMerchant/registrationActivity',
      key: 'pro_customer_development_diy'
    },
    {
      title: '小程序',
      desc: '微信生态的核心入口',
      img: 'https://qnm.hunliji.com/o_1cvmnpl5u1h5i1qnk1akfglo1nb0f.png',
      link: '#/localMerchant/marketingCenter/selectVersion',
      key: 'pro_customer_development_select_version'
    },
    {
      title: '微官网',
      desc: '店铺专属移动官网',
      img: 'https://qnm.hunliji.com/o_1cvmnpl5u18c41v2g1ikrok61gf0e.png',
      link: '#/localMerchant/weiShopSetting',
      key: 'pro_customer_development_weishop'
    }
  ]
}

// 运营管理
export const OPERATION_MANAGEMENT = {
  title: '运营管理',
  desc: '轻松管理线上店铺',
  list: [
    {
      title: '多店铺管理',
      desc: '在线管理多家店铺',
      img: 'https://qnm.hunliji.com/o_1cvmnpl5u6ng1nii1aka1aidqkdc.png',
      link: '#/localMerchant/marketingCenter/detail/74',
      key: 'pro_operation_management_detail_74'
    }
  ]
}

export const APPLICATION_LIST = [
  DECORATION,
  MARKETING,
  CUSTOMER_DEVELOPMENT,
  OPERATION_MANAGEMENT
]
